module.exports = {
      id: "logo-small-usage",
      viewBox: "0 0 192 28",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#logo-small",
      toString: function () {
        return this.url;
      }
    }